<div class="content-wrapper">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <tds-footer id="footerid" mode-variant="primary" style="margin-top: 25px;"></tds-footer>
</div>
